import { useEffect, useState } from "react";
import { getProductSerials, getProductSerialsDrafts } from "../../products/functions";
import Loading from "../../atoms/loading";
import NewSerial from "../../serials/registerSerials/newSerial";
import Serial from "../../serials/registerSerials/serial";
import Button from "../../atoms/button";
import { useNavigate } from "react-router-dom";
import CopyIcon from "../../../img/copyIcon";
import { statusFlow } from "../../utils/allProductStatus";
import { getScoreTitle } from "../../utils/gradingTypes";
import { getVisibleGradeFields, renderApplicableGradeValue } from "../../utils/serialGradeFields";

const ProductSerials = ({ user, productData, setProductData }) => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [productSerials, setProductSerials] = useState([]);

    useEffect(() => {
        doGetProductSerials();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setProductData(pd => { return { ...pd, serials: productSerials } });
        // eslint-disable-next-line
    }, [productSerials]);

    const doGetProductSerials = async () => {
        if (!productData) {
            return null;
        }
        setLoading(true);
        const data = await getProductSerials(user?.token, productData?._id);
        if (!data?.type === "success") {
            setLoading(false);
            return null;
        }
        const data2 = await getProductSerialsDrafts(user?.token, productData?._id);
        if (!data2?.type === "success") {
            setLoading(false);
            return null;
        }
        setProductSerials([...data?.data, ...data2?.data?.filter(d => d?.isDraft)]);
        setLoading(false);
    }

    const goToTagGenerator = () => {
        navigate("/manafix/serials/tags", { state: { origin: "products", products: [productData?._id] } });
    }

    const getStatusIndex = () => {
        if (!statusFlow?.[productData?.delivery]) {
            return false;
        }
        const gradedIndex = Object?.keys(statusFlow?.[productData?.delivery])?.indexOf("GRADED");
        const currentIndex = Object?.keys(statusFlow?.[productData?.delivery])?.indexOf(productData?.status);
        return currentIndex >= gradedIndex;
    }

    const copyGradesToClipboard = () => {
        const gradesString = productSerials?.map(ps => {
            const visibleGrades = getVisibleGradeFields(ps, productData);
            const gradeLines = [
                ...visibleGrades.subgrades.map(field => `${field.label}: ${renderApplicableGradeValue(field.value)}`),
                ...(visibleGrades.autographNote ? [`${visibleGrades.autographNote.label}: ${renderApplicableGradeValue(visibleGrades.autographNote.value)}`] : []),
                ...(visibleGrades.generalScore ? [`Nota Final: ${renderApplicableGradeValue(visibleGrades.generalScore.value)} (${getScoreTitle(visibleGrades.generalScore.value) || "-"})`] : [])
            ];
            return `
            ${ps?.serialNumber}\n
            ${ps?.gradableModel?.name} ${ps?.gradableModel?.numbering}
            ${gradeLines.join("\n            ")}\n
            --- 
            `
        })?.join("");
        navigator.clipboard.writeText(gradesString);
    }


    if (loading) {
        return (
            <div className="m-4 border border-[#666] p-2">
                <div className="w-fit m-auto">
                    <Loading />
                </div>
            </div>
        )
    }
    return (
        <div className="m-4 border border-[#666] p-2 bg-monao relative">
            {
                getStatusIndex() ?
                    <div onClick={copyGradesToClipboard} className="absolute top-2 left-2 cursor-pointer" title="Copiar notas"><CopyIcon fill="#d59106" /></div>
                    : null
            }
            <h2 className="text-center text-lg mb-0">Seriais do pedido</h2>
            <Button classes="bg-purple-300 hover:bg-purple-500 disabled:bg-[#777] absolute top-2 right-1" disabled={productSerials?.length < productData?.numberOfCards} click={goToTagGenerator}>Gerar etiquetas</Button>
            <h3 className="mt-0 mb-4 text-center text-sm">Cadastrados: {productSerials?.length || 0}/{productData?.numberOfCards}</h3>
            {
                productSerials?.length < productData?.numberOfCards ?
                    <NewSerial product={productData} user={user} refresh={doGetProductSerials} />
                    : null
            }
            <div className="max-h-[400px] overflow-y-scroll">
                {
                    productSerials?.map((s, i) => (
                        <Serial user={user} serial={s} product={productData} index={i} key={i} refresh={doGetProductSerials} setProductSerials={setProductSerials} />
                    ))
                }
            </div>
        </div>
    )
}

export default ProductSerials;
